var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "email",
    xmlns: "http://www.w3.org/2000/svg",
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_283",
    "data-name": "Ellipse 283",
    cx: 45,
    cy: 45,
    r: 45,
    fill: "rgba(182,190,52,0.1)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17767",
    "data-name": "Group 17767",
    transform: "translate(15 21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11089",
    "data-name": "Path 11089",
    d: "M0,4V42.435H60V4L30,23.217Z",
    transform: "translate(0 4.565)",
    fill: "#b6be34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11090",
    "data-name": "Path 11090",
    d: "M0,5.283,30,21.7,60,5.283V2H0Z",
    fill: "#b6be34"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.e1a090161d87e39b3787c7d1f72cd8a5.svg";
export { ForwardRef as ReactComponent };